import custom from './custom';
import invite from './invite';
import promoteJob from './promoteJob';
import promoteContent from './promoteContent';
import leaderboardIndividual from './leaderboardIndividual';
import leaderboardOverall from './leaderboardOverall';
import collectiveGoal from './collectiveGoal';

import inMobiCustom from './inMobi/custom';
import inMobiInvite from './inMobi/invite';
import inMobiPromoteJob from './inMobi/promoteJob';
import inMobiJobTable from './inMobi/jobTable';
import inMobiPromoteContent from './inMobi/promoteContent';
import inMobiLeaderboardIndividual from './inMobi/leaderboardIndividual';
import inMobiLeaderboardOverall from './inMobi/leaderboardOverall';
import inMobiCollectiveGoal from './inMobi/collectiveGoal';

export default client => {
  if (client === 'inMobi') {
    return [
      inMobiCustom,
      inMobiInvite,
      inMobiPromoteJob,
      inMobiJobTable,
      inMobiPromoteContent,
      inMobiLeaderboardIndividual,
      inMobiLeaderboardOverall,
      inMobiCollectiveGoal,
    ];
  }
  return [
    custom,
    invite,
    promoteJob,
    promoteContent,
    leaderboardIndividual,
    leaderboardOverall,
    collectiveGoal,
  ];
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/emails/index.js